import { gql } from '@apollo/client';

// CONTRACT: password-Feld ist BEWUSST ausgeschlossen — Bcrypt-Hashes dürfen nicht ins Browser-Memory.
// Siehe auch: apps/frontend/src/services/requestToServerSchemas/querySchemas/getAllUser.js
const getAllUser = gql`
  query {
    getAllUser {
      id
      username
      first_name
      last_name
      email
      enabled
      mcp_enabled
      last_login
      roles
    }
  }
`;
export default getAllUser;
